module.exports = __webpack_public_path__ + "img/about-barangay.3b5c7c4b.jpg";